<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        >
          <div class="col-md-6 col-sm my-1 compu-purpose-filter">
            <label class="data-label">Propósito de la Reunión</label>
            <multiselect
              v-model="model.search.filters.purposes"
              :options="model.search.collections.purposes"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :show-labels="false"
              track-by="id"
              label="name"
              placeholder="Seleccionar"
              class="compu-purpose-multiselect"
            />
          </div>
        </filter-manager>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  name: 'CompuAppointmentSummary',
  components: {
    PageHeader,
    FilterManager,
    Multiselect,
  },
  data: () => ({
    currentAcademicYearId: null,
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Reporte de Citas Coordinadas',
      routes: ['Informes', 'Reporte de Citas Coordinadas'],
    },
    model: {
      search: {
        collections: {
          schools: [],
          districts: [],
          purposes: [],
        },
        filters: {
          dateFrom: null,
          dateTo: null,
          district: null,
          school: null,
          purposes: [],
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
      return [
        {
          name: 'dateFrom',
          component: 'custom-date-picker',
          label: 'Fecha Desde',
          placeholder: 'Fecha Desde',
          error: 'La Fecha Desde es requerida.',
          validations: 'required',
          class: 'col-md-3',
          classContainer: 'date-width-container',
          value: this.model.search.filters.dateFrom,
        },
        {
          name: 'dateTo',
          component: 'custom-date-picker',
          label: 'Fecha Hasta',
          placeholder: 'Fecha Hasta',
          error: 'La Fecha Hasta es requerida.',
          validations: 'required',
          class: 'col-md-3',
          classContainer: 'date-width-container',
          value: this.model.search.filters.dateTo,
        },
        {
          name: 'district',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Distrito',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.districts,
          value: this.model.search.filters.district,
          onChanged: this.onChangeDistrict,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school,
          disabled: !this.model.search.filters.district,
        },
      ]
    },
  },
  async mounted() {
    await this.setFilters()
  },
  methods: {
    async setFilters() {
      const { data: currentAcademicYear } = await AcademicYearServices.getCurrentAcademicYear()
      this.currentAcademicYearId = currentAcademicYear.id

      const [districts, purposes] = await Promise.all([
        LocationServices.getDistricts({
          academicYearId: this.currentAcademicYearId,
        }),
        ReportServices.getReport('compuappointmentpurposes', {}),
      ])

      const purposeOptions = Array.isArray(purposes.data)
        ? purposes.data
        : purposes.data?.data || purposes.data?.items || []

      this.model.search.collections.districts = districts.data
      this.$set(this.model.search.collections, 'purposes', purposeOptions)
    },
    async onChangeDistrict() {
      this.model.search.filters.school = null
      this.model.search.collections.schools = []

      if (!this.model.search.filters.district) return

      const { data } = await LocationServices.getSchools({
        academicYearId: this.currentAcademicYearId,
        districtId: this.model.search.filters.district.id,
      })

      this.model.search.collections.schools = data
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      if (this.model.search.filters.dateFrom > this.model.search.filters.dateTo) {
        this.ShowToast(
          'Atención',
          'La Fecha Hasta no puede ser menor a la Fecha Desde.',
          'error'
        )
        return
      }

      await ReportServices.getReport('compuappointmentsummary', {
        dateFrom: this.model.search.filters.dateFrom,
        dateTo: this.model.search.filters.dateTo,
        schoolId: this.model.search.filters.school?.id,
        districtId: this.model.search.filters.district?.id,
        purposeIds: this.model.search.filters.purposes.map((purpose) => purpose.id).join(','),
      }).then((res) => DocumentServices.Download(res.data))
    },
  },
}
</script>

<style lang="scss" scoped>
.compu-purpose-filter {
  min-width: 320px;
}

.compu-purpose-multiselect ::v-deep .multiselect__content-wrapper {
  min-width: 100%;
}

.compu-purpose-multiselect ::v-deep .multiselect__option {
  white-space: normal;
  line-height: 1.35;
}

.compu-purpose-multiselect ::v-deep .multiselect__placeholder {
  color: #495057;
  opacity: 0.8;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400 !important;
  line-height: 1.6;
}
</style>
